import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Select,
} from "@mui/material";
import { useFormik } from "formik";
import { t } from "i18next";
import { useState } from "react";
import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "../../../../Components/MDBox";
import MDButton from "../../../../Components/MDButton";
import MDInput from "../../../../Components/MDInput";
import MDTypography from "../../../../Components/MDTypography";
import { FieldRange } from "../../../../Types/Api/DTO/FieldRangeDto";
import { ConditionKindEnum } from "../../../../Types/Enums/ConditionKindEnum";
import * as Yup from "yup";
import pxToRem from "../../../../Asset/theme/functions/pxToRem";
import { conditionsParamsAction } from "../../../../Context/redux/actions";
import { ConditionalFieldDto } from "../../../../Types/Api/DTO/ConditionalField";
import { v4 as uuidv4 } from "uuid";

const validationSchema = Yup.object().shape({
  ParamName: Yup.string().required(" الزامی است"),
  GhabzRowsKindEnum: Yup.string().required(" الزامی است"),
  ParamMin: Yup.string().when("GhabzRowsKindEnum", {
    is: (GhabzRowsKindEnum: any) => {
      return GhabzRowsKindEnum == 2 || GhabzRowsKindEnum == 3;
    },
    then: Yup.string().required(" الزامی است"),
  }),
  ParamMax: Yup.string().when("GhabzRowsKindEnum", {
    is: (GhabzRowsKindEnum: any) => {
      return GhabzRowsKindEnum == 1 || GhabzRowsKindEnum == 3;
    },
    then: Yup.string().required(" الزامی است"),
  }),
  ParamEqual: Yup.string().when("GhabzRowsKindEnum", {
    is: (GhabzRowsKindEnum: any) => {
      return GhabzRowsKindEnum == 0;
    },
    then: Yup.string().required(" الزامی است"),
  }),
  ParamAmount: Yup.string().required(" الزامی است"),
});
function PaperComponent(props: any) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
export default function AddCondition({ addModalOpen, setAddModalOpen }: any) {
  let symboledParams: FieldRange[] = useSelector(
    (state: any) => state.symboledParams
  );
  let conditionsParams: ConditionalFieldDto[] = useSelector(
    (state: any) => state.conditionsParams
  );
  const [kindCondition, setKindCondition] = useState<
    ConditionKindEnum | string
  >("");
  const dispatch = useDispatch();

  const handleKindChange = (kindString: string | ConditionKindEnum) => {
    formik.setFieldValue("ParamMin", "");
    formik.setFieldValue("ParamMax", "");
    formik.setFieldValue("ParamEqual", "");
    if (typeof kindString === "string") {
      kindString = parseInt(kindString);
    }
    setKindCondition(kindString);
    formik.setFieldValue("GhabzRowsKindEnum", kindString);
  };
  const handleClick = (e: any) => {
    formik.handleSubmit();
  };
  const formik = useFormik({
    initialValues: {
      GhabzRowsKindEnum: "",
      ParamMin: "",
      ParamMax: "",
      ParamEqual: "",
      ParamAmount: "",
      ParamName: "",
    },
    onSubmit: (e) => {
      let selectedFieldFCond = symboledParams.find(
        (p) => p.Symbole === e.ParamName
      );
      if (selectedFieldFCond) {
        let newCondition: ConditionalFieldDto = {
          uuid: uuidv4(),
          GhabzRowsKindEnum: parseInt(e.GhabzRowsKindEnum),
          ParamMin: e.ParamMin,
          ParamMax: e.ParamMax,
          ParamEqual: e.ParamEqual,
          ParamAmount: e.ParamAmount,
          ParamName: e.ParamName,
          Symbole: e.ParamName,
          Field: selectedFieldFCond.Field,
        };
        dispatch(conditionsParamsAction([...conditionsParams, newCondition]));
        setAddModalOpen(false);
      }

      formik.resetForm();
      setKindCondition("");
    },
    validationSchema: validationSchema,
  });
  return (
    <>
      <Dialog
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          <MDTypography variant="h">افزودن شرط</MDTypography>
        </DialogTitle>
        <DialogContent>
          <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
            <Grid container spacing={3} flexDirection={"row"}>
              <Grid item container>
                <Grid item xs={6} md={6} lg={4} alignSelf="center">
                  <MDTypography fontSize={14}>پارامتر</MDTypography>
                </Grid>
                <Grid item xs={6} md={6} lg={8}>
                  <Select
                    name={"ParamName"}
                    onChange={(e) =>
                      formik.setFieldValue("ParamName", e.target.value)
                    }
                    native
                    defaultValue={formik.values.ParamName}
                    id="grouped-native-select"
                    fullWidth
                    error={
                      formik.touched.ParamName &&
                      Boolean(formik.errors.ParamName)
                    }
                  >
                    <option value={""}>بدون انتخاب</option>
                    {symboledParams
                      .filter((p) => p.Symbole !== "@")
                      .map((r) => {
                        return (
                          <option key={r.Field.key} value={r.Symbole}>
                            {r.Field.name + " (" + r.Symbole + " )"}
                          </option>
                        );
                      })}
                  </Select>
                  {formik.touched.ParamName && formik.errors.ParamName && (
                    <MDTypography
                      color={"error"}
                      fontSize={pxToRem(12)}
                      sx={{ margin: "0 12px" }}
                    >
                      {formik.errors.ParamName}
                    </MDTypography>
                  )}
                </Grid>
              </Grid>
              <Grid item container>
                <Grid item xs={6} md={6} lg={4} alignSelf="center">
                  <MDTypography fontSize={14}>نوع شرط</MDTypography>
                </Grid>
                <Grid item xs={6} md={6} lg={8}>
                  <Select
                    name={"GhabzRowsKindEnum"}
                    onChange={(e) => {
                      formik.setFieldValue("GhabzRowsKindEnum", e.target.value);
                      handleKindChange(e.target.value);
                    }}
                    // onChange={(e) => handleKindChange(e.target.value)}
                    native
                    value={kindCondition}
                    id="grouped-native-select"
                    fullWidth
                    error={
                      formik.touched.GhabzRowsKindEnum &&
                      Boolean(formik.errors.GhabzRowsKindEnum)
                    }
                  >
                    <option value={""}>بدون انتخاب</option>
                    {Object.keys(ConditionKindEnum)
                      .filter((value) => isNaN(Number(value)) === false)
                      .map((r) => {
                        return (
                          <option key={Math.random()} value={r}>
                            {t(ConditionKindEnum[parseInt(r)])}
                          </option>
                        );
                      })}
                  </Select>
                  {formik.touched.GhabzRowsKindEnum &&
                    formik.errors.GhabzRowsKindEnum && (
                      <MDTypography
                        color={"error"}
                        fontSize={pxToRem(12)}
                        sx={{ margin: "0 12px" }}
                      >
                        {formik.errors.GhabzRowsKindEnum}
                      </MDTypography>
                    )}
                </Grid>
              </Grid>
              <Grid item container>
                <Grid item xs={6} md={6} lg={4} alignSelf="center">
                  <MDTypography fontSize={14}>
                    مقدار شرط نماد کمتر از
                  </MDTypography>
                </Grid>
                <Grid item xs={6} md={6} lg={8}>
                  <MDInput
                    name="ParamMin"
                    onChange={formik.handleChange}
                    fullWidth
                    label="کمتر از "
                    type="number"
                    disabled={
                      !(
                        kindCondition === ConditionKindEnum.LessThan ||
                        kindCondition === ConditionKindEnum.Between
                      )
                    }
                    error={
                      formik.touched.ParamMin && Boolean(formik.errors.ParamMin)
                    }
                    helperText={
                      formik.touched.ParamMin && formik.errors.ParamMin
                    }
                    value={formik.values.ParamMin}
                  />
                </Grid>
              </Grid>
              <Grid item container>
                <Grid item xs={6} md={6} lg={4} alignSelf="center">
                  <MDTypography fontSize={14}>
                    مقدار شرط نماد بیشتر از
                  </MDTypography>
                </Grid>
                <Grid item xs={6} md={6} lg={8}>
                  <MDInput
                    name="ParamMax"
                    onChange={formik.handleChange}
                    fullWidth
                    label="بیشتر از "
                    type="number"
                    disabled={
                      !(
                        kindCondition === ConditionKindEnum.MoreThan ||
                        kindCondition === ConditionKindEnum.Between
                      )
                    }
                    error={
                      formik.touched.ParamMax && Boolean(formik.errors.ParamMax)
                    }
                    helperText={
                      formik.touched.ParamMax && formik.errors.ParamMax
                    }
                    value={formik.values.ParamMax}
                  />
                </Grid>
              </Grid>
              <Grid item container>
                <Grid item xs={6} md={6} lg={4} alignSelf="center">
                  <MDTypography fontSize={14}>
                    مقدار شرط نماد برابر با
                  </MDTypography>
                </Grid>
                <Grid item xs={6} md={6} lg={8}>
                  <MDInput
                    name="ParamEqual"
                    fullWidth
                    label="برابر با "
                    onChange={formik.handleChange}
                    disabled={kindCondition !== ConditionKindEnum.Equal}
                    error={
                      formik.touched.ParamEqual &&
                      Boolean(formik.errors.ParamEqual)
                    }
                    helperText={
                      formik.touched.ParamEqual && formik.errors.ParamEqual
                    }
                    value={formik.values.ParamEqual}
                  />
                </Grid>
              </Grid>
              <Grid item container>
                <Grid item xs={6} md={6} lg={4} alignSelf="center">
                  <MDTypography fontSize={14}>ارزش مقدار نماد</MDTypography>
                </Grid>
                <Grid item xs={6} md={6} lg={8}>
                  <MDInput
                    name="ParamAmount"
                    onChange={formik.handleChange}
                    fullWidth
                    label=" ارزش مقدار نماد"
                    type="number"
                    error={
                      formik.touched.ParamAmount &&
                      Boolean(formik.errors.ParamAmount)
                    }
                    helperText={
                      formik.touched.ParamAmount && formik.errors.ParamAmount
                    }
                    value={formik.values.ParamAmount}
                  />
                </Grid>
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Grid container justifyContent={"flex-start"}>
            <MDButton onClick={handleClick}>تایید</MDButton>
            <MDButton
              autoFocus
              onClick={() => {
                formik.resetForm();
                setAddModalOpen(false);
              }}
            >
              بستن
            </MDButton>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
}
